"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var date2yyyymmdd = exports.date2yyyymmdd = function date2yyyymmdd(time, separator) {
  var date = new Date(time);
  var year = date.getFullYear();
  var mon = date.getMonth() + 1;
  var day = date.getDate();
  return [year, mon, day].join(separator);
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/lib/date-transformer.js
 ** module id = 829
 ** module chunks = 0
 **/